module.exports = __webpack_public_path__ + "img/mi-lab.b35e3449.svg";